import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=4cc413fa&"
import script from "./BlogList.vue?vue&type=script&lang=js&"
export * from "./BlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=4cc413fa&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc413fa')) {
      api.createRecord('4cc413fa', component.options)
    } else {
      api.reload('4cc413fa', component.options)
    }
    module.hot.accept("./BlogList.vue?vue&type=template&id=4cc413fa&", function () {
      api.rerender('4cc413fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/blog/BlogList.vue"
export default component.exports